export enum ApplianceDetailsSteppedMultiPlanFormField {
  ApplianceCodeBuiltIn = 'applianceCodeBuiltIn',
  BrandCode = 'brandCode',
  PurchaseDate = 'purchaseDate',
  PurchasePrice = 'purchasePrice',
}
